"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.server = exports.entity = exports.player = void 0;
const path_1 = __importDefault(require("path"));
const fs_1 = __importDefault(require("fs"));
let loadedPlugins = {};
const player = function (player, serv) {
    for (const plugin of Object.values(loadedPlugins)) {
        plugin.player.call(plugin, player, serv);
    }
};
exports.player = player;
const entity = function (entity, serv) {
    for (const plugin of Object.values(loadedPlugins)) {
        plugin.entity.call(plugin, entity, serv);
    }
};
exports.entity = entity;
const server = async function (serv, settings) {
    loadedPlugins = {};
    serv['loadedPlugins'] = loadedPlugins;
    if (!settings.pluginsFolder || !settings.worldFolder)
        return;
    let plugins = [];
    try {
        plugins = await fs_1.default.promises.readdir(path_1.default.join(settings.worldFolder, 'plugins'));
    }
    catch (err) {
        serv.warn('Skipping plugins folder: cannot find plugins folder');
        return;
    }
    for (const plugin of plugins) {
        // match .js but not .disabled.js
        if (plugin.match(/\.(js|mjs)$/) && !plugin.includes('.disabled.')) {
            const pluginName = plugin.split('.').slice(0, -1).join('.');
            const moduleContent = await fs_1.default.promises.readFile(path_1.default.join(settings.worldFolder, 'plugins', plugin), 'utf8');
            const module = await loadPlugin(moduleContent);
            loadedPlugins[pluginName] = module;
            serv.info(`Loading plugin: ${pluginName}`);
            module.server.call(module, serv, settings);
        }
    }
};
exports.server = server;
const loadPlugin = (moduleContent) => {
    // remove shebang
    moduleContent = moduleContent.replace(/^#!.*\n/, '');
    const blob = new Blob([moduleContent], { type: 'application/javascript' });
    const moduleUrl = URL.createObjectURL(blob);
    return import(/* webpackIgnore: true */ `${moduleUrl}`).then(module => {
        URL.revokeObjectURL(moduleUrl);
        return module;
    });
};
